<div class="warning-modal" *ngIf="showUnsupportedBrowserWarning">
  <p i18n="Warning|Unsupported browser warning @@warningUnsupportedBrowser">
    We detected that you are using a browser that is not officialy supported by
    Lightspeed Restaurant. Please download
    <a href="https://www.google.com/chrome/" target="_blank">Google Chrome</a>
    or <a href="https://www.apple.com/safari/" target="_blank">Safari</a> to
    benefit the full experience.
  </p>
  <button
    name="unsupported-browser-close"
    (click)="dismiss()"
    class="warning-modal__close"
  ></button>
</div>
